/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Allow_SubscribersInputs */

const en_story_allow_subscribers = /** @type {(inputs: Story_Allow_SubscribersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allow Subscribers?`)
};

const es_story_allow_subscribers = /** @type {(inputs: Story_Allow_SubscribersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Permitir Suscriptores?`)
};

const fr_story_allow_subscribers = /** @type {(inputs: Story_Allow_SubscribersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autoriser les souscripteurs ?`)
};

const de_story_allow_subscribers = /** @type {(inputs: Story_Allow_SubscribersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnenten zulassen?`)
};

const id_story_allow_subscribers = /** @type {(inputs: Story_Allow_SubscribersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Izinkan Pelanggan?`)
};

/** @type {(inputs: Story_Allow_SubscribersInputs) => LocalizedString} */
const ja_story_allow_subscribers = en_story_allow_subscribers;

/** @type {(inputs: Story_Allow_SubscribersInputs) => LocalizedString} */
const zh_story_allow_subscribers = en_story_allow_subscribers;

/** @type {(inputs: Story_Allow_SubscribersInputs) => LocalizedString} */
const ar_story_allow_subscribers = en_story_allow_subscribers;

/** @type {(inputs: Story_Allow_SubscribersInputs) => LocalizedString} */
const it_story_allow_subscribers = en_story_allow_subscribers;

/** @type {(inputs: Story_Allow_SubscribersInputs) => LocalizedString} */
const ru_story_allow_subscribers = en_story_allow_subscribers;

/** @type {(inputs: Story_Allow_SubscribersInputs) => LocalizedString} */
const pt_story_allow_subscribers = en_story_allow_subscribers;

/** @type {(inputs: Story_Allow_SubscribersInputs) => LocalizedString} */
const ko_story_allow_subscribers = en_story_allow_subscribers;

/**
* | output |
* | --- |
* | "Allow Subscribers?" |
*
* @param {Story_Allow_SubscribersInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const story_allow_subscribers = /** @type {((inputs?: Story_Allow_SubscribersInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Allow_SubscribersInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_story_allow_subscribers(inputs)
	if (locale === "es") return es_story_allow_subscribers(inputs)
	if (locale === "fr") return fr_story_allow_subscribers(inputs)
	if (locale === "de") return de_story_allow_subscribers(inputs)
	if (locale === "ja") return ja_story_allow_subscribers(inputs)
	if (locale === "zh") return zh_story_allow_subscribers(inputs)
	if (locale === "ar") return ar_story_allow_subscribers(inputs)
	if (locale === "id") return id_story_allow_subscribers(inputs)
	if (locale === "it") return it_story_allow_subscribers(inputs)
	if (locale === "ru") return ru_story_allow_subscribers(inputs)
	if (locale === "pt") return pt_story_allow_subscribers(inputs)
	return ko_story_allow_subscribers(inputs)
});